/** The 404 page. */

export const NOT_FOUND = {
  eyebrow: '404',
  title: 'Page not found',
  text: "The page you're looking for doesn't exist or has moved.",
  cta: { label: 'Back to home', href: '/' },
}
